

































































































import { Component, Vue } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import { ReportStep, DataValidation } from "@/models/graphql-global-types";
import { DataProgress } from "@/models/graphql-global-types";
import { ReportFilterStore, TimeFrame } from "@/store/ReportFilterStore";
import { NewReportStore } from "@/store/NewReportStore";
import lodash from "lodash";

@Component({
  props: {},
  components: {
    Fragment
  }
})
export default class ReportFilterCard extends Vue {
  private DataProgress = DataProgress;
  private DataValidation = DataValidation;
  private TimeFrame = TimeFrame;

  get shouldShowDataValidationFilter() {
    return lodash.some(ReportFilterStore.filteredReports, report => !lodash.isNil(report.dataValidation));
  }

  get customers() {
    return NewReportStore.customersForReports;
  }
  get customer() {
    return ReportFilterStore.customer;
  }
  get selectedProgress() {
    return ReportFilterStore.progress;
  }
  get selectedTimeFrame() {
    return ReportFilterStore.timeFrame;
  }
  get selectedDataValidations() {
    return ReportFilterStore.dataValidations;
  }

  public setProgress(progress: DataProgress) {
    ReportFilterStore.setProgress(progress);
  }

  public setTimeFrame(timeFrame: TimeFrame) {
    ReportFilterStore.setTimeFrame(timeFrame);
  }

  public setCustomer(customer: string) {
    ReportFilterStore.setCustomer(customer);
  }

  public setDataValidation(dataValidation: DataValidation) {
    ReportFilterStore.setDataValidation(dataValidation);
  }
}
